import { LastMessageSystem } from '@halo/ui-chat-react';
import {
  MsgEncryptFailedContent,
  type MsgEncryptFailedContentProps,
} from './msg-encrypt-failed-content';

export interface MsgEncryptFailedPreviewProps extends MsgEncryptFailedContentProps {}

export const MsgEncryptFailedPreview = memo(function MsgEncryptFailedPreview({
  message,
}: MsgEncryptFailedPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgEncryptFailedContent message={message} />
    </LastMessageSystem>
  );
});
